import * as React from 'react';
import { MenuItemLink, useCreatePath } from 'react-admin';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import Divider from '@mui/material/Divider';
import DescriptionIcon from '@mui/icons-material/Description';
import SubjectIcon from '@mui/icons-material/Subject';
import CategoryIcon from '@mui/icons-material/Category';
import PublicIcon from '@mui/icons-material/Public';
import ForumIcon from '@mui/icons-material/Forum';
import FunctionsIcon from '@mui/icons-material/Functions';
import FlagIcon from '@mui/icons-material/Flag';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

export default function AppMenu({ onMenuClick, dense = false, ...rest }) {
    const createPath = useCreatePath();
    const rdfLink = createPath({ type: 'list', resource: 'rdf' });
    const predicatesLink = createPath({ type: 'list', resource: 'predicates' });
    const subjectsLink = createPath({ type: 'list', resource: 'subjects' });
    const subjectVariantsLink = createPath({ type: 'list', resource: 'subject-variants' });
    const oobjectsLink = createPath({ type: 'list', resource: 'oobjects' });
    const oobjectVariantsLink = createPath({ type: 'list', resource: 'oobject-variants' });
    const commentReportsLink = createPath({ type: 'list', resource: 'comment-reports' });
    const entityReportsLink = createPath({ type: 'list', resource: 'entity-reports' });
    const contactMessagesLink = createPath({ type: 'list', resource: 'contact-messages' });

    return (
        <List dense={dense} {...rest}>
            <ListSubheader component="div">Ressources</ListSubheader>
            <MenuItemLink
                to={rdfLink}
                primaryText="RDF"
                onClick={onMenuClick}
                leftIcon={<DescriptionIcon />}
            />
            <MenuItemLink
                to="/rdf-graph"
                primaryText="Graphe RDF global"
                onClick={onMenuClick}
                leftIcon={<AccountTreeIcon />}
            />
            <MenuItemLink
                to={predicatesLink}
                primaryText="Liste des prédicats"
                onClick={onMenuClick}
                leftIcon={<FunctionsIcon />}
            />
            <Divider sx={{ my: 1.5 }} />
            <ListSubheader component="div">Moderation</ListSubheader>
            <MenuItemLink
                to={subjectsLink}
                primaryText="Subjects"
                onClick={onMenuClick}
                leftIcon={<SubjectIcon />}
            />
            <MenuItemLink
                to={subjectVariantsLink}
                primaryText="Subject Variants"
                onClick={onMenuClick}
                leftIcon={<SubjectIcon />}
            />
            <MenuItemLink
                to={oobjectsLink}
                primaryText="Oobjects"
                onClick={onMenuClick}
                leftIcon={<CategoryIcon />}
            />
            <MenuItemLink
                to={oobjectVariantsLink}
                primaryText="Oobject Variants"
                onClick={onMenuClick}
                leftIcon={<CategoryIcon />}
            />
            <Divider sx={{ my: 1.5 }} />
            <ListSubheader component="div">Outils</ListSubheader>
            <MenuItemLink
                to={commentReportsLink}
                primaryText="Comment Reports"
                onClick={onMenuClick}
                leftIcon={<ForumIcon />}
            />
            <MenuItemLink
                to={entityReportsLink}
                primaryText="Entity Reports"
                onClick={onMenuClick}
                leftIcon={<FlagIcon />}
            />
            <MenuItemLink
                to={contactMessagesLink}
                primaryText="Messages Contact"
                onClick={onMenuClick}
                leftIcon={<ContactMailIcon />}
            />
            <MenuItemLink
                to="/sitemap-tools"
                primaryText="Sitemap"
                onClick={onMenuClick}
                leftIcon={<PublicIcon />}
            />
            <MenuItemLink
                to="/observability"
                primaryText="Observabilité"
                onClick={onMenuClick}
                leftIcon={<QueryStatsIcon />}
            />
        </List>
    );
}
